<template>
  <div class="">

    <Head />

    <div class="main lessonPlans">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('員/志工登入') }}</li>
          </ol>
        </div>
      </nav>

      <div class="lessonPlans_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ $t('員/志工登入') }}</h2>
          </div>

          <div class="box login_box">

            <div class="title">
              <h3>{{ $t('登入') }}</h3>
            </div>

            <div class="group">
              <label for="email" class="form-label">{{ $t('電子郵件') }}</label>
              <input type="email" class="form-control" id="email" :placeholder="$t('請輸入電子郵件')" v-model="email">
            </div>

            <div class="group password_box">
              <label for="password">{{ $t('密碼') }}</label>

              <div class="password">
                <input :type="showPassword ? 'text' : 'password'" class="form-control" id="password"
                  :placeholder="$t('請輸入密碼')" v-model="password" @keyup.enter="login" />

                <button type="button" :class="['password_btn', { active: showPassword }]" @click="togglePassword"
                  :aria-label="showPassword ? $t('隱藏密碼') : $t('顯示密碼')" :aria-pressed="showPassword.toString()">
                  <img :src="showPassword
                    ? 'img/password_no.svg'
                    : 'img/password_yes.svg'
                    " alt="toggle password" />
                </button>
              </div>
            </div>

            <div class="alert alert-danger" role="alert" v-if="errorMessage">
              {{ errorMessage }}
            </div>

            <div class="btn_box">
              <button class="login_btn" @click="login" :disabled="isLoading">
                <span v-if="!isLoading">{{ $t('登入') }}</span>
                <span v-else>{{ $t('登入中...') }}</span>
              </button>
            </div>

          </div>

        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';
import AccesskeyLink from '@/views/AccesskeyLink.vue'

export default {
  name: 'ScheduleLogin',
  components: {
    Head,
    Footer,
    AccesskeyLink,
  },

  data() {
    return {
      // 表單資料
      email: '',
      password: '',
      
      // 密碼顯示
      showPassword: false,
      
      // 錯誤訊息
      errorMessage: '',
      
      // 載入中
      isLoading: false,
    };
  },

  methods: {
    // 密碼顯示切換
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    // 登入驗證
    async login() {
      this.errorMessage = '';
      
      // 驗證必填
      if (!this.email || !this.password) {
        this.errorMessage = this.$t('請輸入電子郵件和密碼');
        return;
      }
      
      // 驗證電子郵件格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.errorMessage = this.$t('請輸入有效的電子郵件格式');
        return;
      }
      
      this.isLoading = true;
      
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/ValidateScheduleLogin`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Email: this.email,
            Password: this.password,
          }),
        });
        
        const data = await response.json();
        
        if (data.ok) {
          // 儲存登入資訊到 sessionStorage (不限制時間，直到頁面關閉或登出)
          sessionStorage.setItem('scheduleToken', data.token);
          sessionStorage.setItem('scheduleCSVId', data.csvId.toString());
          sessionStorage.setItem('scheduleEmail', this.email);
          sessionStorage.setItem('scheduleName', data.name);
          sessionStorage.setItem('scheduleAccountType', data.accountType);
          sessionStorage.setItem('scheduleLoginTime', new Date());
          
          // 跳轉到排班列表頁
          this.$router.push({ name: 'ScheduleList' });
        } else {
          this.errorMessage = data.message || this.$t('登入失敗，請檢查您的電子郵件和密碼');
        }
      } catch (error) {
        console.error('登入錯誤:', error);
        this.errorMessage = this.$t('登入失敗，請稍後再試');
      } finally {
        this.isLoading = false;
      }
    },

    // 換頁
    gotoPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },

  // 清除錯誤訊息當使用者輸入時
  watch: {
    email() {
      if (this.errorMessage) {
        this.errorMessage = '';
      }
    },
    password() {
      if (this.errorMessage) {
        this.errorMessage = '';
      }
    },
  },
  
  // 檢查是否已登入
  mounted() {
    const token = sessionStorage.getItem('scheduleToken');
    const csvId = sessionStorage.getItem('scheduleCSVId');
    
    if (token && csvId) {
      // 已登入,直接跳轉到列表頁
      this.$router.push({ name: 'ScheduleList' });
    }
  },
}

</script>
